(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-double"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const toggleButtons = document.querySelectorAll("[data-section-toggle]");
    toggleButtons.forEach(function (toggleButton) {
      const toggleId = toggleButton.getAttribute("data-section-toggle");
      const isHiddenByDefault = "true" === toggleButton.getAttribute("data-section-hidden-default");
      if (!toggleId) {
        return;
      }
      const targetSection = document.querySelector(`[data-toggle-id="${toggleId}"]`);
      if (targetSection) {
        if (isHiddenByDefault) {
          targetSection.classList.add("section-hidden");
        }
        toggleButton.addEventListener("click", function (event) {
          event.preventDefault();
          const wasHidden = targetSection.classList.contains("section-hidden");
          targetSection.classList.toggle("section-hidden");
          if (wasHidden) {
            const scrollPosition = window.pageYOffset + targetSection.getBoundingClientRect().top - 100;
            window.scrollTo({ top: Math.max(0, scrollPosition), behavior: "smooth" });
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
